import { render } from 'react-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { initAnalytics } from '../utils/analytics';
import { initMonitoring } from '../utils/monitoring';
import { muteMapboxAbortErrors } from '../utils/muteMapboxAbortErrors';
import RootRoutes from '../routes/RootRoutes';

initAnalytics();
initMonitoring();

const router = createBrowserRouter([RootRoutes]);

document.addEventListener('DOMContentLoaded', () => {
  const rootNode = document.createElement('div');
  rootNode.className = 'root';
  render(
    <RouterProvider router={router} />,
    document.body.appendChild(rootNode),
  );
});

if (process.env.NODE_ENV === 'development') {
  muteMapboxAbortErrors();
}
